import { useFrame, useThree } from '@react-three/fiber';
import { useEffect, useRef } from 'react';
import { useRenderStats } from './stats';

// The pipeline renders several passes a frame; counting stays on across them and is read and
// reset once per frame, before the pipeline draws the next one.
export function RenderStats() {
  const get = useThree((s) => s.get);
  const last = useRef(0);

  useEffect(() => {
    const info = get().gl.info;
    info.autoReset = false;
    return () => {
      info.autoReset = true;
    };
  }, [get]);

  useFrame(({ gl, clock }) => {
    // typed as the WebGL renderer; the node renderer counts draws per frame in drawCalls
    const { drawCalls: calls, triangles } = gl.info.render as unknown as {
      drawCalls: number;
      triangles: number;
    };
    if (clock.elapsedTime - last.current > 0.25) {
      last.current = clock.elapsedTime;
      useRenderStats.setState({ calls, triangles });
    }
    gl.info.reset();
  });

  return null;
}
